import React, { useState } from 'react';
import { NOTIFICATION_TYPES } from '../../utils/constants';

export default function NotificationSettings({ darkMode }) {
  const [toggles, setToggles] = useState({
    run: true,
    bug: true,
    release: true,
    digest: false
  });

  const cardBg = darkMode ? 'bg-[#161922]' : 'bg-white';
  const borderColor = darkMode ? 'border-gray-800/50' : 'border-gray-200';

  const handleToggle = (id) => {
    setToggles(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <div className={`p-10 rounded-3xl border ${cardBg} ${borderColor} animate-in fade-in slide-in-from-right-4 duration-300`}>
      <h3 className="text-lg font-bold mb-8">Notification Preferences</h3>
      
      <div className="space-y-2">
        {NOTIFICATION_TYPES.map((n) => {
          const isActive = toggles[n.id];
          
          return (
            <div 
              key={n.id} 
              className={`flex items-center justify-between p-5 rounded-2xl border ${borderColor} hover:bg-gray-800/20 transition-all cursor-pointer`}
              onClick={() => handleToggle(n.id)}
            >
              <div>
                <p className={`text-sm font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  {n.title}
                </p>
                <p className="text-xs text-gray-500 mt-0.5">
                  {n.desc}
                </p>
              </div>

              {/* DYNAMIC TOGGLE SWITCH */}
              <div className={`w-11 h-6 rounded-full relative transition-colors duration-300 ${
                isActive ? 'bg-purple-600/30' : 'bg-gray-700'
              }`}>
                <div 
                  className={`absolute top-1 w-4 h-4 rounded-full shadow-sm transition-all duration-300 ${
                    isActive 
                      ? 'translate-x-6 bg-purple-500'
                      : 'translate-x-1 bg-gray-400'
                  }`} 
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-10 flex justify-end">
        <button className="px-8 py-3 rounded-xl bg-purple-600 hover:bg-purple-700 text-white font-bold text-sm transition-all shadow-lg shadow-purple-500/20">
          Save Preferences
        </button>
      </div>
    </div>
  );
}
